var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DateTime, Interval } from "luxon";
import * as React from 'react';
import { Button, Dimmer, Form, Grid, Header, Input, Loader, Message, Modal, Segment, Select, TextArea } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { Help } from "../Help";
import { debounce } from "../kit/automated-pro/EditKitForm";
import KitDisplay from "../kit/rna-fish/KitDisplay";
import { uniqueBy } from "../kit/rna-fish/ProbeSetForm";
import ProfileEditForm from "../ProfileEditForm";
import { addressGridRows } from "../ProfilePage";
import { getWithAuthn, postJsonWithAuthn, postWithAuthn } from "../RequestHelpers";
import AllOrdersPage, { dateOnlyFormat, displayLocalTimestamp } from "./AllOrdersPage";
import ChangeAutomatedActionStatus from "./ChangeAutomatedActionStatus";
import DateRangePicker from "./DateRangePicker";
import SimpleFormWithErrorDisplay from "./SimpleFormWithErrorDisplay";
import UpdateDiscountsModal from "./UpdateDiscountsModal";
var SingleUserPage = /** @class */ (function (_super) {
    __extends(SingleUserPage, _super);
    function SingleUserPage(props) {
        var _this = _super.call(this, props) || this;
        _this.editBlackoutDateModal = function (user) {
            var renderEditBlackoutDateModal = function (props) {
                return React.createElement(EditBlackoutDateModal, __assign({ userId: user.id, initialBlackoutStart: user.blackoutStart, initialBlackoutEnd: user.blackoutEnd }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadUser, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit Blackout', labelPosition: 'left' }) },
                React.createElement(Modal.Header, null, "Edit Blackout"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderEditBlackoutDateModal, successMessage: 'Blackout date saved' })));
        };
        _this.editAutomatedActionList = function (userResponse) {
            var renderModalContents = function (props) {
                return React.createElement(ChangeAutomatedActionStatus, __assign({ resourceId: userResponse.user.id, userLevel: true, currentAutomatedActionStatus: userResponse.user.automatedActions, automatedActionOptions: userResponse.automatedActions }, props));
            };
            return React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(Modal, { closeIcon: true, onClose: _this.loadUser, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit Automated Actions', labelPosition: 'left' }) },
                        React.createElement(Modal.Header, null, "Edit"),
                        React.createElement(Modal.Content, null,
                            React.createElement(SimpleFormWithErrorDisplay, { render: renderModalContents, successMessage: 'Successfully Changed Automated Actions List' })))));
        };
        _this.editMetadataModal = function (user) {
            var renderEditMetadata = function (props) {
                return React.createElement(EditMetadataModal, __assign({ userId: _this.props.match.params.id, 
                    // can't invoke this until the response is loaded anyway...
                    initialNotes: user.notes, initialOnOrderEmails: user.onOrderEmails, initialReferringUserReferralId: user.referredBy === null ? "" : (user.referredBy._type === "PERSONAL" ? user.referredBy.id : "") }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadUser, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit metadata', labelPosition: 'left' }) },
                React.createElement(Modal.Header, null, "Edit Metadata"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderEditMetadata, successMessage: 'Metadata saved' })));
        };
        _this.editUserStatusModal = function (user) {
            var renderEditUserStatus = function (props) {
                return React.createElement(EditUserStatusModal, __assign({ user: user }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadUser, trigger: React.createElement(Button, { icon: 'edit', label: user.userStatus === 'LEGACY' ? 'Remove v3.0 Access' : 'Grant v3.0 Access', labelPosition: 'left', size: 'mini' }) },
                React.createElement(Modal.Header, null, "Confirm Edit"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderEditUserStatus, successMessage: 'Status changed' })));
        };
        _this.courierAccountNumberField = function (user) {
            var renderEditCourierAccountNumber = function (props) {
                return React.createElement(EditCourierAccountNumberForm, __assign({ userId: user.id, currentValue: user.courierAccountNumber }, props));
            };
            return React.createElement(React.Fragment, null,
                React.createElement("b", null, user.courierAccountNumber || 'None'),
                "\u00A0\u00A0",
                React.createElement(Modal, { closeIcon: true, onClose: _this.loadUser, trigger: React.createElement(Button, { icon: 'edit', size: 'mini' }) },
                    React.createElement(Modal.Header, null, "Edit Courier Account Number"),
                    React.createElement(Modal.Content, null,
                        React.createElement(SimpleFormWithErrorDisplay, { render: renderEditCourierAccountNumber, successMessage: 'Courier account number updated' }))));
        };
        _this.loadUser = function () {
            _this.setState({ loading: true }, function () {
                _this.getUser()
                    .catch(function (rej) {
                    console.error("Couldn't load user: " + rej);
                });
            });
        };
        _this.getUser = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, getWithAuthn("/admin/users/id/" + encodeURIComponent(this.props.match.params.id))
                        .then(function (resp) {
                        if (resp.ok) {
                            return resp.json();
                        }
                        else {
                            return undefined;
                        }
                    })
                        .then(function (resp) {
                        if (resp === undefined) {
                            _this.setState({
                                loading: false,
                                error: true
                            });
                        }
                        else {
                            _this.setState({
                                error: false,
                                loading: false,
                                response: resp
                                // interval: (resp.user.blackoutStart && resp.user.blackoutEnd) ?
                                //     Interval.fromDateTimes(
                                //         new Date(Date.parse(resp.user.blackoutStart.toString())),
                                //         new Date(Date.parse(resp.user.blackoutEnd.toString())),
                                //     ) : undefined,
                            });
                        }
                    })];
            });
        }); };
        _this.resendEmailVerification = function () {
            if (_this.state.response === undefined) {
                return;
            }
            var email = _this.state.response.user.email;
            _this.setState({
                loading: true,
                resendEmailVerificationSuccess: false,
                resendEmailVerificationError: false
            }, function () {
                postJsonWithAuthn('/user/resend-email-verification', JSON.stringify({ email: email }))
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            resendEmailVerificationSuccess: true
                        });
                    }
                    else {
                        console.error("Couldn't resend verification email: " + resp.status + " " + resp.statusText);
                        _this.setState({
                            loading: false,
                            resendEmailVerificationError: true
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't resend verification email: " + rej);
                    _this.setState({
                        loading: false,
                        resendEmailVerificationError: true
                    });
                });
            });
        };
        _this.clearQboId = function () {
            _this.setState({ loading: true }, function () {
                postWithAuthn("/admin/users/id/" + encodeURIComponent(_this.props.match.params.id) + "/clear-qbo-id")
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.loadUser();
                        return;
                    }
                    else {
                        _this.setState({ loading: false });
                        return undefined;
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load user: " + rej);
                });
            });
        };
        _this.syncQbo = function () {
            _this.setState({ loading: true, qboSyncMessage: undefined }, function () {
                postWithAuthn("/admin/users/id/" + encodeURIComponent(_this.props.match.params.id) + "/sync-qbo")
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            qboSyncMessage: { ok: true, text: 'QuickBooks customer updated from this profile.' }
                        });
                        return;
                    }
                    return resp.json()
                        .then(function (body) { var _a, _b; return (_b = (_a = body.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.msg; })
                        .catch(function () { return undefined; })
                        .then(function (msg) { return _this.setState({
                        loading: false,
                        qboSyncMessage: { ok: false, text: msg !== null && msg !== void 0 ? msg : 'QuickBooks customer could not be updated.' }
                    }); });
                })
                    .catch(function (rej) {
                    console.error("Couldn't sync QBO customer: " + rej);
                    _this.setState({
                        loading: false,
                        qboSyncMessage: { ok: false, text: 'QuickBooks customer could not be updated.' }
                    });
                });
            });
        };
        _this.state = {
            loading: false,
            error: false,
            resendEmailVerificationSuccess: false,
            resendEmailVerificationError: false
        };
        return _this;
    }
    SingleUserPage.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Dimmer.Dimmable, { id: 'non-header-portion' },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                this.state.error &&
                    React.createElement(Message, { negative: true }, "User could not be loaded."),
                this.state.response &&
                    React.createElement(React.Fragment, null,
                        React.createElement(Header, null,
                            "User ",
                            this.state.response.user.id),
                        React.createElement(Grid, { className: 'tight-rows', width: 4 },
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Name"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.name)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Email"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.email)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Email Verified"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                                    this.state.response.user.emailVerified ? 'Yes' : 'No',
                                    "\u00A0\u00A0",
                                    React.createElement(Button, { icon: 'mail', label: 'Resend verification email', labelPosition: 'left', disabled: this.state.loading, onClick: this.resendEmailVerification }))),
                            (this.state.resendEmailVerificationSuccess || this.state.resendEmailVerificationError) &&
                                React.createElement(Grid.Row, null,
                                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }),
                                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                                        this.state.resendEmailVerificationSuccess &&
                                            React.createElement(Message, { positive: true }, "Verification email resent."),
                                        this.state.resendEmailVerificationError &&
                                            React.createElement(Message, { negative: true }, "Verification email could not be resent."))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Organization"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.organization)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Research group"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.researchGroup)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Phone"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.phone)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Category"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.category)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "QuickBooks Customer Id"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                                    this.state.response.user.qboCustomerId,
                                    " ",
                                    this.state.response.user.qboCustomerId && React.createElement(React.Fragment, null,
                                        "| ",
                                        React.createElement(Modal, { closeIcon: true, closeOnDimmerClick: true, closeOnDocumentClick: true, trigger: React.createElement(Button, { labelPosition: 'left', label: 'Clear Quickbooks ID', negative: true, icon: 'x' }) },
                                            React.createElement(Modal.Header, null, "Are you sure you want to clear the users Quickbooks ID?"),
                                            React.createElement(Modal.Content, null,
                                                React.createElement(Button, { onClick: this.clearQboId, labelPosition: 'left', label: 'Clear Quickbooks ID', negative: true, icon: 'x' }))),
                                        "| ",
                                        React.createElement(Button, { onClick: this.syncQbo, labelPosition: 'left', label: 'Sync to Quickbooks', icon: 'sync', title: 'Re-send this profile (name, addresses, phones) to the linked QuickBooks customer' })))),
                            this.state.qboSyncMessage &&
                                React.createElement(Grid.Row, null,
                                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }),
                                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                                        React.createElement(Message, { positive: this.state.qboSyncMessage.ok, negative: !this.state.qboSyncMessage.ok }, this.state.qboSyncMessage.text))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Notes"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                                    React.createElement("pre", { className: 'text-with-whitespace' }, this.state.response.user.notes))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Emails when order is placed"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.onOrderEmails.length > 0
                                    ? this.state.response.user.onOrderEmails.map(function (row) { return row.email; }).join(", ")
                                    : React.createElement("i", null, "None"))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Referred By (Free Text)"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.referredByFreeText)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Created at"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, displayLocalTimestamp(this.state.response.user.createdAt))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "v3.0 access"),
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                                    this.state.response.user.userStatus === 'LEGACY' ? 'Granted' : 'No',
                                    "\u00A0\u00A0",
                                    this.editUserStatusModal(this.state.response.user))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Blackout Dates"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                                    (this.state.response.user.blackoutStart && this.state.response.user.blackoutEnd) &&
                                        React.createElement("b", null,
                                            this.state.response.user.blackoutStart,
                                            " to ",
                                            this.state.response.user.blackoutEnd),
                                    " ",
                                    this.editBlackoutDateModal(this.state.response.user))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Courier Account #"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.courierAccountNumberField(this.state.response.user))),
                            React.createElement(Header, null, "Referral"),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Referral Id"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.usersReferral.referralId.id)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Referral Link"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                                    React.createElement("a", { href: this.state.response.user.usersReferral.bitlyLink }, this.state.response.user.usersReferral.bitlyLink))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null, this.editMetadataModal(this.state.response.user))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, this.editAutomatedActionList(this.state.response)),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                                    React.createElement("b", null, this.state.response.user.automatedActions.map(function (a, index) {
                                        return React.createElement(React.Fragment, { key: index },
                                            a,
                                            React.createElement("br", null));
                                    }))))),
                        React.createElement(Header, null, "Orders"),
                        React.createElement(AllOrdersPage, { history: this.props.history, userId: this.props.match.params.id, embedded: true }),
                        React.createElement(Header, null, "Shipping Address"),
                        React.createElement(Grid, { className: 'tight-rows' }, addressGridRows(this.state.response.user.shippingAddress, KitDisplay.labelWidth, KitDisplay.valueWidth)),
                        React.createElement(Header, null, "Billing Address"),
                        React.createElement(Grid, { className: 'tight-rows' },
                            addressGridRows(this.state.response.user.billingAddress, KitDisplay.labelWidth, KitDisplay.valueWidth),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Billing Email"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.billingEmail)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Billing Phone"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.billingPhone)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement(Modal, { closeIcon: true, onClose: this.loadUser, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit profile', labelPosition: 'left' }) },
                                        React.createElement(Modal.Header, null, "Update profile"),
                                        React.createElement(Modal.Content, null,
                                            React.createElement(ProfileEditForm, { buttonIcon: 'save', buttonLabel: 'Save changes', disableOnSuccess: true, endpoint: "/admin/users/id/" + encodeURIComponent(this.state.response.user.id), hideOnSuccess: true, includePassword: false, initialProfile: this.state.response.user, initialCategory: this.state.response.user.category, successHeader: 'Profile updated', successMessage: React.createElement(React.Fragment, null), legalInput: false, categoryInput: true, referredByInput: false, sendSignUpGaEvent: false })))))),
                        React.createElement(Header, null, "Discounts"),
                        React.createElement(Grid, { className: 'tight-rows' },
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-FISH (v3.0) Probe - catalog"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.v3RnaFishProbeSetCatalog))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-FISH (v3.0) Probe - custom"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.v3RnaFishProbeSetCustom))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-FISH / 2\u00BAIF (v3.0) Amplifier"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.v3ManualAmplifier))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-FISH (v3.0) Buffers"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.v3RnaFishBuffers))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "2\u00BAIF Probe"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.v3SecondaryIfProbe))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "2\u00BAIF Buffers"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.v3SecondaryIfBuffers))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-ISH Probe - catalog"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.automatedProProbeSetCatalog))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-ISH Probe - custom"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.automatedProProbeSetCustom))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-ISH Detect"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.automatedProDetect))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold RNA-FISH Probe - catalog"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.goldRnaFishProbeSetCatalog))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold RNA-FISH Probe - custom"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.goldRnaFishProbeSetCustom))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold RNA-FISH / 2\u00BAIF Amplifier"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.goldManualAmplifier))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold RNA-FISH Buffers"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.goldRnaFishBuffers))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold 2\u00BAIF Probe"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.goldSecondaryIfProbe))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold 2\u00BAIF Buffers"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.goldSecondaryIfBuffers))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Manual Pro Detect"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.manualProDetect))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Manual Gold IF Encoder"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.manualGoldIfEncoder))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Automated Gold IF - Encoder"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.automatedGoldIfEncoder))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Automated Gold IF - Detect"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.automatedGoldIfDetect))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'dollar sign', label: 'Update discounts', labelPosition: 'left' }), onClose: this.loadUser },
                                        React.createElement(Modal.Header, null, "Update discounts"),
                                        React.createElement(Modal.Content, null,
                                            React.createElement(Modal.Description, null, "Discounts can be either blank for no discount or a number in (0, 100] with up to 3 fractional digits."),
                                            React.createElement(UpdateDiscountsModal, { initialValues: this.state.response.user.discounts, userId: this.props.match.params.id })))))))));
    };
    SingleUserPage.prototype.componentDidMount = function () {
        this.loadUser();
    };
    return SingleUserPage;
}(React.PureComponent));
export default SingleUserPage;
var formatDiscount = function (d) {
    if (d.length > 0) {
        return d + "%";
    }
    else {
        return '-';
    }
};
var EditBlackoutDateModal = /** @class */ (function (_super) {
    __extends(EditBlackoutDateModal, _super);
    function EditBlackoutDateModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onIntervalChange = function (interval) {
            _this.setState({
                interval: interval,
                blackoutStart: interval.start.toFormat(dateOnlyFormat),
                blackoutEnd: interval.end.toFormat(dateOnlyFormat)
            });
        };
        _this.submitBlackoutDate = function () {
            var _a, _b;
            _this.props.postRequest("/admin/users/id/" + encodeURIComponent(_this.props.userId) + "/blackout", {
                blackoutStart: (_a = _this.state.interval) === null || _a === void 0 ? void 0 : _a.start.toFormat(dateOnlyFormat),
                blackoutEnd: (_b = _this.state.interval) === null || _b === void 0 ? void 0 : _b.end.toFormat(dateOnlyFormat)
            });
        };
        _this.removeBlackoutDates = function () {
            _this.setState({
                interval: undefined,
                blackoutStart: undefined,
                blackoutEnd: undefined
            }, function () {
                _this.props.postRequest("/admin/users/id/" + encodeURIComponent(_this.props.userId) + "/blackout", {
                    blackoutStart: undefined,
                    blackoutEnd: undefined
                });
            });
        };
        _this.state = {
            interval: (_this.props.initialBlackoutStart != null && _this.props.initialBlackoutEnd != null)
                ? Interval.fromDateTimes(DateTime.fromISO(_this.props.initialBlackoutStart), DateTime.fromISO(_this.props.initialBlackoutEnd)) : undefined,
            blackoutStart: _this.props.initialBlackoutStart,
            blackoutEnd: _this.props.initialBlackoutEnd
        };
        return _this;
    }
    EditBlackoutDateModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Grid, { columns: 1, className: 'tight-rows' },
                React.createElement(Grid.Row, { textAlign: "center" },
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/blackoutDate', labelContent: React.createElement(React.Fragment, null) },
                            React.createElement(DateRangePicker, { onIntervalChange: this.onIntervalChange, dayRangeOptions: [], interval: this.state.interval, includePresets: false })))),
                React.createElement(Grid.Row, { textAlign: "right" },
                    React.createElement(Grid.Column, null,
                        React.createElement(Button, { color: 'red', onClick: this.removeBlackoutDates, label: 'Clear', icon: 'x' }),
                        "\u00A0",
                        React.createElement(Button, { color: 'green', onClick: this.submitBlackoutDate, label: 'Set', icon: 'check' })))));
    };
    return EditBlackoutDateModal;
}(React.PureComponent));
var EditMetadataModal = /** @class */ (function (_super) {
    __extends(EditMetadataModal, _super);
    function EditMetadataModal(props) {
        var _this = _super.call(this, props) || this;
        _this.debounceSearchQueryChange = debounce(function (event, data) {
            _this.onSearchQueryChange(event, data);
        }, 500);
        _this.addBlankEmailRow = function () {
            _this.setState(function (prevState) { return ({
                onOrderEmails: prevState.onOrderEmails.concat({ email: '', templateId: '' })
            }); });
        };
        _this.submit = function () {
            if (_this.state.referringUserReferralId.trim() !== "") {
                _this.props.postRequest("/admin/users/id/" + encodeURIComponent(_this.props.userId) + "/metadata", {
                    notes: _this.state.notes,
                    onOrderEmails: _this.state.onOrderEmails,
                    referringUserReferralId: _this.state.referringUserReferralId
                });
            }
            else {
                _this.props.postRequest("/admin/users/id/" + encodeURIComponent(_this.props.userId) + "/metadata", {
                    notes: _this.state.notes,
                    onOrderEmails: _this.state.onOrderEmails
                });
            }
        };
        _this.onNotesChange = function (event) {
            var value = event.currentTarget.value;
            _this.setState({ notes: value });
        };
        _this.onReferralIdChange = function (_, data) {
            var value = data.value;
            _this.setState({ referringUserReferralId: value });
        };
        _this.onSearchQueryChange = function (_, data) {
            if (data.searchQuery.length !== 0) {
                _this.loadAllUsers(data.searchQuery);
            }
        };
        _this.onSearch = function (options, value) {
            if (value.trim().length === 0) {
                return [];
            }
            else {
                return uniqueBy(options, function (o) { return o.value; });
            }
        };
        _this.loadAllUsers = function (userFilter) {
            _this.getReferralUsers(userFilter)
                .then(function (users) {
                _this.setState({ users: users });
            })
                .catch(function (rej) {
                console.error("Couldn't load users: " + rej);
            });
        };
        _this.getReferralUsers = function (userFilter) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, postJsonWithAuthn('/admin/users/all/referrals', JSON.stringify({ userFilter: userFilter }))
                        .then(function (resp) {
                        return resp.json();
                    })
                        .then(function (profiles) { return profiles.users; })];
            });
        }); };
        _this.getAuthrocketUsers = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, getWithAuthn("/admin/users/authrocket/all")
                        .then(function (resp) {
                        if (resp.ok) {
                            return resp.json();
                        }
                        else {
                            throw new Error(resp.status + " " + resp.statusText);
                        }
                    })];
            });
        }); };
        _this.state = {
            notes: _this.props.initialNotes,
            onOrderEmails: _this.props.initialOnOrderEmails,
            referringUserReferralId: _this.props.initialReferringUserReferralId,
            users: [],
            authrocketUserList: [],
            authrocketLoading: true
        };
        return _this;
    }
    EditMetadataModal.prototype.componentDidMount = function () {
        var _this = this;
        Promise.all([
            this.getReferralUsers(""),
            this.getAuthrocketUsers()
        ])
            .then(function (_a) {
            var users = _a[0], authrocketUserList = _a[1];
            _this.setState({
                users: users,
                authrocketUserList: authrocketUserList,
                authrocketLoading: false
            });
        })
            .catch(function (rej) {
            console.error("Couldn't load users: " + rej);
            _this.setState({ authrocketLoading: false });
        });
    };
    EditMetadataModal.prototype.render = function () {
        var _this = this;
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errorPath: '/notes', errors: this.props.state.errors, required: true, labelContent: 'Notes' },
                React.createElement(TextArea, { placeholder: '...', onChange: this.onNotesChange, value: this.state.notes })),
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/referredBy', labelContent: 'Referred By' },
                React.createElement(Select, { options: this.state.users.map(function (u) {
                        var _a, _b;
                        return {
                            text: u.name + " (" + ((_b = (_a = _this.state.authrocketUserList
                                .find(function (a) { var _a; return a.id === ((_a = u.authrocketId) === null || _a === void 0 ? void 0 : _a.id); })) === null || _a === void 0 ? void 0 : _a.email) !== null && _b !== void 0 ? _b : u.accountEmail) + ")",
                            description: u.usersReferral.referralId.id,
                            value: u.usersReferral.referralId.id
                        };
                    }), loading: this.state.authrocketLoading, disabled: this.state.authrocketLoading, search: this.onSearch, onSearchChange: this.debounceSearchQueryChange, placeholder: 'Please enter referral id', onChange: this.onReferralIdChange, value: this.state.referringUserReferralId })),
            React.createElement(Form.Field, null,
                React.createElement("label", null,
                    "Emails to send when the user places an order ",
                    React.createElement(Help, null, "The template ids are SendGrid template ids")),
                React.createElement(Segment, null,
                    React.createElement(Grid, { columns: 3 },
                        this.state.onOrderEmails.length === 0 ?
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement("i", null, "None"))) : React.createElement(React.Fragment, null),
                        this.state.onOrderEmails.map(function (ooe, index) {
                            var onEmailChange = function (_, data) {
                                var email = data.value;
                                _this.setState(function (prevState) {
                                    var newEmails = prevState.onOrderEmails.slice();
                                    newEmails[index] = {
                                        email: email,
                                        templateId: newEmails[index].templateId
                                    };
                                    return { onOrderEmails: newEmails };
                                });
                            };
                            var onTemplateIdChange = function (_, data) {
                                var templateId = data.value;
                                _this.setState(function (prevState) {
                                    var newEmails = prevState.onOrderEmails.slice();
                                    newEmails[index] = {
                                        email: newEmails[index].email,
                                        templateId: templateId
                                    };
                                    return { onOrderEmails: newEmails };
                                });
                            };
                            var remove = function () {
                                _this.setState(function (prevState) {
                                    var copy = prevState.onOrderEmails.slice();
                                    copy.splice(index, 1);
                                    return ({
                                        onOrderEmails: copy
                                    });
                                });
                            };
                            return React.createElement(Grid.Row, { key: index },
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { errors: _this.props.state.errors, errorPath: "/onOrderEmails/" + index + "/email", labelContent: "Email #" + (index + 1) },
                                        React.createElement(Input, { onChange: onEmailChange, value: ooe.email }))),
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { errors: _this.props.state.errors, errorPath: "/onOrderEmails/" + index + "/templateId", labelContent: "Template id #" + (index + 1) },
                                        React.createElement(Input, { style: { display: 'inline-box' }, onChange: onTemplateIdChange, value: ooe.templateId }))),
                                React.createElement(Grid.Column, null,
                                    React.createElement(Form.Field, null,
                                        React.createElement("label", null, "\u00A0"),
                                        React.createElement(Button, { icon: 'x', label: 'Remove', labelPosition: 'left', onClick: remove, negative: true }))));
                        }),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, null,
                                React.createElement(Button, { icon: 'add', label: 'Add a row', labelPosition: 'left', onClick: this.addBlankEmailRow })),
                            React.createElement(Grid.Column, null))))),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'save', label: 'Save metadata', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return EditMetadataModal;
}(React.PureComponent));
var EditUserStatusModal = /** @class */ (function (_super) {
    __extends(EditUserStatusModal, _super);
    function EditUserStatusModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onConfirm = function () {
            _this.props.postRequest("/admin/users/id/" + encodeURIComponent(_this.props.user.id) + "/user-status", {
                newUserStatus: _this.props.user.userStatus === 'LEGACY' ? 'NON_LEGACY' : 'LEGACY'
            });
        };
        return _this;
    }
    EditUserStatusModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("p", { style: { fontWeight: 'bold', whiteSpace: "pre-line" } },
                "Are you sure you want to ",
                this.props.user.userStatus === 'LEGACY' ? 'remove' : 'grant',
                " v3.0 access for ",
                this.props.user.name,
                "?"),
            React.createElement(Button, { className: 'fish-button', disabled: this.props.state.loading || this.props.state.success, icon: 'save', label: 'Confirm', labelPosition: 'left', onClick: this.onConfirm, positive: true }));
    };
    return EditUserStatusModal;
}(React.PureComponent));
var EditCourierAccountNumberForm = /** @class */ (function (_super) {
    __extends(EditCourierAccountNumberForm, _super);
    function EditCourierAccountNumberForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onCourierAccountNumberChange = function (_, data) {
            _this.setState({ courierAccountNumber: data.value });
        };
        _this.onSave = function () {
            _this.props.postRequest("/admin/users/id/" + encodeURIComponent(_this.props.userId) + "/courier-account-number", { courierAccountNumber: _this.state.courierAccountNumber });
        };
        _this.state = {
            courierAccountNumber: props.currentValue
        };
        return _this;
    }
    EditCourierAccountNumberForm.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Input, { label: 'Courier Account #', value: this.state.courierAccountNumber, onChange: this.onCourierAccountNumberChange }),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, onClick: this.onSave, icon: 'save', label: 'Save', labelPosition: 'left', positive: true }));
    };
    return EditCourierAccountNumberForm;
}(React.PureComponent));
//# sourceMappingURL=SingleUserPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/SingleUserPage.js
// module id = 1447
// module chunks = 0